// import { useEffect, useState } from "react";

// const CountdownTimerRefund = ({ expireMinutes }) => {
//   const [timeLeft, setTimeLeft] = useState(null);

//   useEffect(() => {
//     const durationInMs = expireMinutes * 60 * 1000;
//     const targetTime = new Date().getTime() + durationInMs;

//     const calculateTimeLeft = () => {
//       const now = new Date().getTime();
//       const remainingTime = targetTime - now;
//       return remainingTime > 0 ? remainingTime : 0;
//     };

//     // Initial calculation
//     setTimeLeft(calculateTimeLeft());

//     const timer = setInterval(() => {
//       const remaining = calculateTimeLeft();
//       setTimeLeft(remaining);
//       if (remaining <= 0) clearInterval(timer);
//     }, 1000);

//     return () => clearInterval(timer);
//   }, [expireMinutes]); // Re-run effect if expireMinutes changes

//   const formatTimeLeft = () => {
//     if (timeLeft <= 0) return "Expired";

//     const minutes = Math.floor((timeLeft / (1000 * 60)) % 60);
//     const seconds = Math.floor((timeLeft / 1000) % 60);

//     return `${minutes}m ${seconds}s`;
//   };

//   return <>{formatTimeLeft()}</>;
// };

// export default CountdownTimerRefund;


import { useEffect, useRef, useState } from "react";

const CountdownTimerRefund = ({ expireMinutes }) => {
  const [timeLeft, setTimeLeft] = useState(null);
  const targetTimeRef = useRef(null); // Store target time persistently

  useEffect(() => {
    if (!expireMinutes || isNaN(expireMinutes)) return;

    // Only set target time once to avoid reset on re-render
    if (!targetTimeRef.current) {
      const durationInMs = expireMinutes * 60 * 1000;
      targetTimeRef.current = Date.now() + durationInMs;
    }

    const calculateTimeLeft = () => {
      const now = Date.now();
      const remainingTime = targetTimeRef.current - now;
      return remainingTime > 0 ? remainingTime : 0;
    };

    setTimeLeft(calculateTimeLeft());

    const timer = setInterval(() => {
      const remaining = calculateTimeLeft();
      setTimeLeft(remaining);
      if (remaining <= 0) clearInterval(timer);
    }, 1000);

    return () => clearInterval(timer);
  }, [expireMinutes]);

  const formatTimeLeft = () => {
    if (timeLeft === null) return "";
    if (timeLeft <= 0) return "Expired";

    const hours = Math.floor((timeLeft / (1000 * 60 * 60)) % 24);
    const minutes = Math.floor((timeLeft / (1000 * 60)) % 60);
    const seconds = Math.floor((timeLeft / 1000) % 60);

    return `${hours > 0 ? `${hours}h ` : ""}${minutes}m ${seconds < 10 ? "0" : ""}${seconds}s`;
  };

  return <span>{formatTimeLeft()}</span>;
};

export default CountdownTimerRefund;
